import { useEffect } from "react";
import { usePostPropertyLandMutation } from "web_myplann/Api/Portfolio/Mutations/usePostPropertyLandMutation";
import { Routing } from "web_myplann/Infrastructure/Routing/Routing";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { LandFormFields } from "web_myplann/Portfolio/Forms/LandForm/LandFormFields";
import { LAND_FORM_DEFAULT_VALUES } from "web_myplann/Portfolio/Forms/LandForm/landFormDefaults";
import {
	getLandFormSchema,
	type LandFormInput,
} from "web_myplann/Portfolio/Forms/LandForm/landFormSchema";
import { RealEstateTypeRow } from "web_myplann/Portfolio/Forms/RealEstateForm/RealEstateTypeRow";
import type { RealEstateType } from "web_myplann/Portfolio/Forms/RealEstateForm/realEstateTypes";
import { PortfolioFormShell } from "web_myplann/Portfolio/PortfolioShared/PortfolioFormShell";
import { useCreatePortfolioForm } from "web_myplann/Portfolio/PortfolioShared/useCreatePortfolioForm";

type CreateLandFormProps = {
	type: RealEstateType;
	onTypeChange: (type: RealEstateType) => void;
	registerSnapshot: (getValues: () => LandFormInput) => void;
	initialValues: LandFormInput | undefined;
};

export const CreateLandForm = ({
	type,
	onTypeChange,
	registerSnapshot,
	initialValues,
}: CreateLandFormProps) => {
	const { t } = useResource();

	const { mutate: createLand, isPending } = usePostPropertyLandMutation();

	const { form, onSubmit } = useCreatePortfolioForm({
		schema: getLandFormSchema(t),
		defaultValues: initialValues ?? LAND_FORM_DEFAULT_VALUES,
		mutate: createLand,
		successRoute: Routing.Portfolio.PortfolioAddLandSuccess.path(),
	});

	useEffect(() => {
		registerSnapshot(form.getValues);
	}, [registerSnapshot, form.getValues]);

	return (
		<PortfolioFormShell
			onSubmit={onSubmit}
			submitLabel={t(Resources.Portfolio.AddRealEstate.submit)}
			disabled={!form.formState.isDirty}
			loading={isPending}
		>
			<RealEstateTypeRow mode="select" value={type} onChange={onTypeChange} />
			<LandFormFields control={form.control} />
		</PortfolioFormShell>
	);
};
